import { otherLoadedEntities, productFormBreadcrumb } from "./products/product-form-nav-reducer";
import { availabilities } from './allotments/availabilities-reducer';
import { currencies, configOptions } from './initialize/initialize-reducer';

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.

export const reducers = {
	otherLoadedEntities,
	productFormBreadcrumb,
	availabilities,
	currencies,
	configOptions,
};



// WEBPACK FOOTER //
// ./src/store/index.ts